// @flow
import * as React from 'react'
import { Flex, colors } from 'components/common'

type NestedFlexFieldsProps = {
  children: React.Node,
  style?: {
    [key: string]: string | number
  }
}

const NestedFlexFields = ({ children, style, ...props }: NestedFlexFieldsProps) => (
  <Flex
    column
    style={{
      padding: '1rem 1.5rem',
      backgroundColor: colors.gray25,
      ...style
    }}
    {...props}
  >
    {children}
  </Flex>
)

export { NestedFlexFields }
